import { ToastContainerDirective } from 'ngx-toastr';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastDisplayService {
  private _toastContainer: ToastContainerDirective;

  public setToastContainer(container: ToastContainerDirective): void {
    this._toastContainer = container;
  }

  get toastContainer(): ToastContainerDirective {
    return this._toastContainer;
  }
}
